import { defineNuxtPlugin } from 'nuxt/app';
import { initInstallPrompt } from '~/composables/useInstallPrompt';

/**
 * `beforeinstallprompt` is one-shot and fires during initial page load. The
 * banner component only reaches the browser with the homepage chunk, so a
 * client-side navigation into `/` from another route would load the composable
 * after the event had already been missed — no Android banner, and Chromium's
 * own mini-infobar left unsuppressed. Binding at app boot avoids both.
 */
export default defineNuxtPlugin(() => {
  initInstallPrompt();
});
